import httpClient from "./httpClient";

const contracts = {
  getContractList() {
    return httpClient
      .get('/api/contracts')
      .then((response) => (response.success ? response.contracts : undefined));
  },
  getTokenList() {
    return httpClient
      .get('/api/contracts/tokens')
      .then((response) =>
        response.success ? response.contractTokens : undefined
      );
  },
};

export default contracts;
